import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import NewComment from '../FeedBackCard/NewComment';

const useStyles = makeStyles({
  root: {
    minWidth: 675,
    margin: '1.3rem 0',
    padding: 7
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)'
  },
  title: {
    fontSize: 12,
    fontFamily: 'PT sans',
    color: '#FFB714',
    FontWeight: 'bolder',
    border: '1px solid #FFB714',
    borderRadius: 11,
    padding: '0 9px'
  },
  name: {
    marginTop: 10,
    fontFamily: 'PT sans',
    fontWeight: 'bold',
    fontSize: 14,
    color: '#252525'
  },
  status: {
    marginBottom: 12,
    fontFamily: 'PT sans',
    fontSize: '14px',
    color: '#A7AAAE'
  },
  time: {
    fontFamily: 'PT sans',
    fontSize: '14px',
    color: '#252523'
  },
  option: {
    marginBottom: 25,
    fontFamily: 'PT sans',
    fontWeight: '600',
    fontSize: '16px',
    color: '#002380'
  }
});

const OrdersCard = ({ dataviz }) => {
  const classes = useStyles();

  return (
    <Card className={classes.root} elevation={0}>
      <CardContent>
        <div className={classes.container}>
          <Typography className={classes.title} gutterBottom>
            Orders
          </Typography>
          <Typography className={classes.time} gutterBottom>
            31 min ago
          </Typography>
        </div>

        <Typography className={classes.name} component="h2" variant="h5">
          Slavcho Karbashewski
        </Typography>
        <Typography className={classes.status}>Advisor (Praexo)</Typography>
        <Typography className={classes.option}>
          Hide proposed allocation
        </Typography>
        {dataviz}
        {/* <Typography component="h1" variant="h1">
          Data
          <br />
          visualisation
        </Typography> */}
      </CardContent>
      <NewComment />
    </Card>
  );
};

export default OrdersCard;
